import { createFileRoute, Navigate } from '@tanstack/react-router'
import SignUpPage from 'pages/sign-up/SignUpPage'
import { useIsLoggedIn } from 'hooks/useIsLoggedIn'

export const Route = createFileRoute('/signup')({
  component: SignUpRoute,
})

function SignUpRoute() {
  const isLoggedIn = useIsLoggedIn()

  if (isLoggedIn) {
    return <Navigate to="/app" />
  }

  return <SignUpPage />
}
